import type { LmsAdapter, MappingFormData } from './types';

export const moodleAdapter: LmsAdapter = {
  lmsType: 'moodle',
  displayName: 'Moodle',
  shortDescription: 'Koble Moodle-kurs til en godkjent studieplan',
  colors: {
    bg: 'bg-orange-50',
    border: 'border-orange-200',
    badge: 'bg-orange-100 text-orange-800',
    primary: 'bg-orange-600 hover:bg-orange-700'
  },
  courseIdField: {
    label: 'Moodle kurs-ID',
    placeholder: 'F.eks. 1234',
    helpText: 'Heltall fra Moodle-URL etter /course/view.php?id=...',
    inputType: 'number',
    validate: (v) => /^\d+$/.test(v.trim()) ? null : 'Moodle kurs-ID må være et heltall',
    parse: (v) => parseInt(v.trim(), 10)
  },
  courseNameField: {
    label: 'Kursnavn i Moodle',
    placeholder: 'Eksakt tittel som vist i Moodle',
    required: true
  },
  endpoints: {
    listMappingsForMember: (mid) => `/api/moodle/mappings/member/${mid}`,
    listMappingsForIntegration: (iid) => `/api/moodle/mappings/${iid}`,
    createMappingForMember: (mid) => `/api/moodle/mappings/member/${mid}`,
    updateMapping: (id) => `/api/moodle/mappings/${id}`,
    deleteMapping: (id) => `/api/moodle/mappings/${id}`,
    listCoursesByMember: (mid) => `/api/moodle/courses/member/${mid}`
  },
  normalizeCourseList: (rawCourses) =>
    (rawCourses as Array<{ id: number; fullname: string; shortname?: string; visible?: boolean }>)
      .map(c => ({
        id: String(c.id),
        name: c.fullname,
        secondary: [c.shortname, c.visible === false ? 'skjult' : null].filter(Boolean).join(' · ')
      })),
  buildCreateBody: (data: MappingFormData) => ({
    moodle_course_id: parseInt(data.lmsCourseId, 10),
    moodle_course_name: data.lmsCourseName,
    study_plan_id: data.studyPlanId,
    assessment_type: data.assessmentType,
    no_self_assessment_confirmed: data.noSelfAssessmentConfirmed,
    controlled_conditions_confirmed: data.controlledConditionsConfirmed,
    module_codes: data.moduleCodes.length > 0 ? data.moduleCodes : null,
    ects_credits: data.ectsCredits ?? null,
    certificate_title: data.certificateTitle ?? null,
    certificate_description: data.certificateDescription ?? null,
    // Fase 2.6 B-wire-rest
    framework_rationale: data.frameworkRationale || undefined,
    has_rubric: Boolean(data.hasRubric)
  }),
  buildUpdateBody: (data: MappingFormData) => ({
    moodle_course_name: data.lmsCourseName,
    assessment_type: data.assessmentType,
    no_self_assessment_confirmed: data.noSelfAssessmentConfirmed,
    controlled_conditions_confirmed: data.controlledConditionsConfirmed,
    module_codes: data.moduleCodes.length > 0 ? data.moduleCodes : null,
    ects_credits: data.ectsCredits ?? null,
    certificate_title: data.certificateTitle ?? null,
    certificate_description: data.certificateDescription ?? null,
    // Fase 2.6 B-wire-rest
    framework_rationale: data.frameworkRationale || undefined,
    has_rubric: Boolean(data.hasRubric)
  })
};
